import { render, staticRenderFns } from "./CreateNewToponym.vue?vue&type=template&id=2f53e414&"
import script from "./CreateNewToponym.vue?vue&type=script&lang=js&"
export * from "./CreateNewToponym.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewToponym.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports